<template>
  <div id="glitter-confirm-account">
    <h4>{{ $t('confirmAccountView_headline') }}</h4>

    <form ref="confirmAccountForm" @submit.prevent="confirmAccountSubmit()">
      <div class="glitter-form-row">
        <label for="glitter-email" class="required-true">{{ $t('label_email') }}</label>
        <input type="email" required name="email" v-model="formData.email" id="glitter-email" />
      </div>
      <div class="glitter-form-row">
        <label for="glitter-code" class="required-true">{{ $t('label_code') }}</label>
        <input type="text" required name="code" v-model="formData.code" id="glitter-code" />
      </div>
      <div class="glitter-button-row">
        <button type="submit">{{ $t('buttonConfirmAccount') }}</button>
      </div>
      <div class="glitter-button-row">
        <a class="glitterResend" :title="$t('buttonResendCode')" target="_self" href="#" @click.prevent="resendCode()">{{ $t('buttonResendCode') }}</a>
      </div>
    </form>

  </div>
</template>

<script>
import ProcessService from '@/services/process'
import { A11yMixin } from './_mixin'

export default {
  name: 'confirm-account',
  mixins: [A11yMixin],
  data () {
    return {
      formData: {
        email: ProcessService.tempEmail || ''
      }
    }
  },
  methods: {
    confirmAccountSubmit () {
      ProcessService.confirmAccountProcess(this.formData)
    },
    resendCode () {
      ProcessService.resendConfirmCode(this.formData.email)
    }
  }
}
</script>
